import { X, SlidersHorizontal } from 'lucide-react'
import FilterSidebar from './FilterSidebar'

interface MobileFilterOverlayProps {
  isOpen: boolean
  onClose: () => void
  filters: any
  expandedSections: {[key: string]: boolean}
  loading: boolean
  onFilterChange: (key: string, value: any) => void
  onAmenityChange: (amenity: string) => void
  onToggleSection: (section: string) => void
  onApplyFilters: () => void
  onResetFilters: () => void
  onOpenCalendar?: () => void
}

const MobileFilterOverlay = ({
  isOpen,
  onClose,
  filters,
  expandedSections,
  loading,
  onFilterChange,
  onAmenityChange,
  onToggleSection,
  onApplyFilters,
  onResetFilters,
  onOpenCalendar
}: MobileFilterOverlayProps) => {
  if (!isOpen) return null

  return (
    <div 
      className="lg:hidden fixed inset-0 z-50 bg-black/50 backdrop-blur-sm" 
      onClick={onClose}
    >
      <div 
        className="absolute right-0 top-0 h-full w-full max-w-sm bg-white shadow-2xl overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between z-10">
          <div className="flex items-center gap-2">
            <SlidersHorizontal className="h-5 w-5 text-primary-500" />
            <h3 className="text-xl font-bold text-gray-900">Filters</h3>
          </div>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="h-5 w-5 text-gray-600" />
          </button>
        </div>
        <div className="p-6">
          <FilterSidebar
            filters={filters}
            expandedSections={expandedSections}
            loading={loading}
            onFilterChange={onFilterChange}
            onAmenityChange={onAmenityChange}
            onToggleSection={onToggleSection}
            onApplyFilters={onApplyFilters}
            onResetFilters={onResetFilters}
            onOpenCalendar={onOpenCalendar}
          />
        </div>
      </div>
    </div>
  )
}

export default MobileFilterOverlay

